import {Injectable} from '@angular/core';
import {CurrentUser} from 'app/core/services/auth.service';

@Injectable({providedIn: 'root'})
export class AuthServiceHelper {
    private _currentUser: CurrentUser = null;
    get currentUser(): CurrentUser {
        return this._currentUser;
    }

    setCurrentUser(user: CurrentUser) {
        this._currentUser = user;
    }
}
